module.exports = __webpack_public_path__ + "static/media/img-manner-activity.9b39401c.svg";